// extracted by mini-css-extract-plugin
export default {"policy":"Policy_policy__JY9zh","wrapper":"Policy_wrapper__PLbJh","addr":"Policy_addr__fXrPV","points":"Policy_points__KVCD9","rules":"Policy_rules__fbE2N"};